import { useRouter } from 'next/router'

import useSearchForm from 'app/hooks/useSearchForm'
import { useGetUserBySlug } from 'app/services/Query/user/user.query'
import useAuthStore, { getAuthUserId } from 'app/store/auth.store'
import { REVIEWS_VARIANT } from 'app/utils/constants/status.constants'

interface CustomDefaultValuesFV {
  receive: REVIEWS_VARIANT
  p?: number
}
export const useReviewsView = () => {
  const { query } = useRouter()
  const slug = query.slug as string
  const receiveQuery = query.receive as string
  const userId = useAuthStore(getAuthUserId)

  const { data: userBySlug } = useGetUserBySlug({
    slug,
    options: { enabled: !!userId }
  })

  const { is_seller_reviews, available_listings, id } = userBySlug || {}

  const isReceivedSeller = is_seller_reviews || available_listings
  const startReceive = REVIEWS_VARIANT[receiveQuery] || REVIEWS_VARIANT.seller
  const receiveDefault = isReceivedSeller ? startReceive : REVIEWS_VARIANT.buyer

  const { methods } = useSearchForm<CustomDefaultValuesFV>({
    customDefaultValues: { receive: receiveDefault },
    path: slug && `/store/${slug}/reviews`
  })

  return {
    methods,
    id,
    slug,
    isReceivedSeller
  }
}
